import { render, staticRenderFns } from "./FaqsEdit.vue?vue&type=template&id=a32b845a"
import script from "./FaqsEdit.vue?vue&type=script&lang=js"
export * from "./FaqsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports